import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import { AppConstants } from '../../constants/AppConstants';
import AppActions from '../../app/app_actions';


const EnumI18nActions = Object.freeze({
    LOCAL_I18N: 'LOCAL_I18N',
    LOCAL_I18N_DETAILS: 'LOCAL_I18N_DETAILS',
    // LOCALNEWI18N: 'NEWI18N',
    LOCAL_I18N_LIST: 'LOCAL_I18N_LIST',
    LOCAL_HANDLE_CHANGE_CODICE: 'LOCAL_HANDLE_CHANGE_CODICE',
    LOCAL_UPDATE_I18N: 'LOCAL_UPDATE_I18N',
    LOCAL_INITIALIZED: 'LOCAL_INITIALIZED',
    LOCAL_APP_LANG: 'LOCAL_APP_LANG',
    LOCAL_APP_LANG_EXPORT: "LOCAL_APP_LANG_EXPORT"
});

module.exports.EnumI18nActions = EnumI18nActions;


class LocalizzazioneActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "LocalizzazioneActions";
    }
    get Actions() {

        return EnumI18nActions;
    }


    getI18nList() {
        return function (dispatch) {
            return Rest.post('admin/i18n/load', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumI18nActions.LOCAL_I18N_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    getI18nExport(){
        return function (dispatch, getState){
            let filter = getState().localizzazione.i18n.searchPar;
            return Rest.postForm("admin/i18n/export", {filter : filter}, dispatch).then(
                resolve => {
                    dispatch({ type: EnumI18nActions.LOCAL_APP_LANG_EXPORT, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    
    getI18nDetails(code) {
        return function (dispatch) {
            return Rest.postForm('admin/i18n/details', { code: code }, dispatch).then(
                resolve => {
                    let i18n = {
                        code: code,
                        listApLang: resolve
                    }
                    dispatch({ type: EnumI18nActions.LOCAL_I18N, dato: i18n });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    updateI18n(listApLangIndex, descr) {
        return function (dispatch, getState) {


            let localizzazione = {
                i18n: {
                    listApLang: {
                        [listApLangIndex]: {
                            descr:
                                { $set: descr }
                        }
                    }
                }
            }

            dispatch({
                type: EnumI18nActions.LOCAL_UPDATE_I18N,
                dato: localizzazione
            });
        }
    }

    handleChange(id, value) {
        return function (dispatch, getState) {
            let i18n = getState().localizzazione.i18n
            i18n[id] = value;
            //TODO sistemare e usare una sola ACTION nel reducer LOCAL_UPDATE_I18N
            dispatch({
                type: EnumI18nActions.LOCAL_I18N,
                dato: i18n
            });
        }
    }


    newI18N() {
        return function (dispatch, getState) {
            let i18n = {
                listApLang: [],
                code: null
            }

            //inizializzo una lista di ApLang
            let langs = AppConstants.APP_LANG;
            for (let i = 0; i < langs.length; i++) {
                let object = {};
                object.codLang = langs[i].value;

                i18n.listApLang.push(object);
            }


            dispatch({
                type: EnumI18nActions.LOCAL_I18N, dato: i18n
            });
            dispatch({
                type: EnumI18nActions.LOCAL_APP_LANG, dati: i18n.listApLang
            });
        }
    }


    // setLang() {
    //     return function (dispatch, getState) {
    //         let object = {};
    //         let i18n = new Object();

    //         let i18nList = [];
    //         let langs = AppConstants.APP_LANG;
    //         for (let i = 0; i < langs.length; i++) {
    //             let object = {};
    //             object.codLang = langs[i].value;
    //             i18nList.push(object);
    //         }
    //         i18n.listApLang = i18nList;
    //         i18n.code = "";

    //         dispatch({
    //             type: EnumI18nActions.UPDATE_I18N_LIST,
    //             dato: i18n
    //         },
    //         );
    //     }
    // }

    salvaI18N(history, isModifica) {
        return function (dispatch, getState) {

            let i18nToSave = getState().localizzazione.i18n;

            let url;
            if (isModifica) {
                url = "admin/i18n/update";
            } else {
                url = "admin/i18n/insert";
            }

            return Rest.post(url, i18nToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumI18nActions.LOCAL_I18N_DETAILS, dati: resolve });
                    history.push({ pathname: '/impostazioni/localizzazioneDetails', state: { id: i18nToSave.code } })
                    return resolve;
                },
                function (reject) {
                    dispatch(AppActions.addNotify('WARNING', 'Si è verificto un errore durante l\'inserimento del i18n'));
                    return reject;
                });
        }

    }

    inizilizzaModificaI18n(codice) {
        return function (dispatch, getState) {
            let i18n = {
                code: codice
            }
            // let i18nList = getState().localizzazione.listI18n;
            // let i18nCreate = getState().localizzazione.i18n.listApLang;

            let i18nCreate = getState().localizzazione.i18n.listApLang;
            let temp = i18nCreate;
            // let i18nList = getState().localizzazione.apLangConst;
            let i18nList = [];
            // AppConstants.APP_LANG;
            i18nCreate = i18nList;

            let langs = AppConstants.APP_LANG;
            for (let i = 0; i < langs.length; i++) {
                let object = {};
                object.codLang = langs[i].value;

                i18nCreate.push(object);
            }
            // for (let j = 0; j < i18nList.length; j++) {
            //     for (let i = 0; i < i18nCreate.length; i++) {
            //     // if (i18nCreate)
            //         if (i18nCreate[i].codLang !== i18nList[j].value) {
            //             i18nCreate.push({
            //                 id:
            //                     { lang: i18nList[j].value }
            //             })
            //             // i18nCreate[i].codLang = i18nList[j].value;
            //             break;
            //         }
            //     }
            // }
            for (let i = 0; i < i18nCreate.length; i++) {
                for (let j = 0; j < temp.length; j++) {
                    if (i18nCreate[i].codLang === temp[j].id.lang) {
                        i18nCreate[i].descr = temp[j].descr;
                    }
                }
            }
            i18n.listApLang = i18nCreate;
            dispatch({ type: EnumI18nActions.LOCAL_I18N, dato: i18n });

        }
    }
    cancelEdit() {
        return function (dispatch) {
            dispatch({ type: EnumI18nActions.LOCAL_INITIALIZED });
        }
    }
    deleteLocalizzazione() {
        return function (dispatch, getState) {
            let code = getState().localizzazione.i18n.code;
            return Rest.postForm('admin/i18n/delete', { code: code }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumI18nActions.LOCAL_I18N, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', 'I18n eliminata con successo'));
                    return resolve
                }, reject => {
                    dispatch(AppActions.addNotify('WARNING', 'I18n non si puo\' eliminare'));
                    return reject;

                });
        }
    }

    filterLocalizzazione(){
        return function (dispatch, getState) {
            let searchPar = getState().localizzazione.i18n.searchPar;
            return Rest.postForm('admin/i18n/filter', {searchPar: searchPar}, dispatch).then(
                resolve => {
                    dispatch({ type: EnumI18nActions.LOCAL_I18N_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    clearSearchPar(){
        return function (dispatch, getState){
            let i18n = getState().localizzazione.i18n
            i18n['searchPar'] = '';
            //TODO sistemare e usare una sola ACTION nel reducer LOCAL_UPDATE_I18N
            dispatch({
                type: EnumI18nActions.LOCAL_I18N,
                dato: i18n
            });
        }
    }
};

export default LocalizzazioneActions = new LocalizzazioneActions;